import Modal from '../ui/Modal';
import Btn from '../ui/Button';
import { useSettings } from '../../context/SettingsContext';
import en from '../../locales/en.json';
import hi from '../../locales/hi.json';
import gu from '../../locales/gu.json';

const translations = { en, hi, gu };

export default function ConfirmModal({ title, message, text, onConfirm, onCancel, danger = true, confirmText, loading = false }) {
  const { language = 'en' } = useSettings();
  
  const t = (key) => {
    return translations[language]?.common?.[key] || translations.en?.common?.[key] || key;
  };

  const content = message || text;
  const displayConfirmText = confirmText || t("btn_confirm");

  return (
    <Modal title={title} onClose={loading ? undefined : onCancel} popup centered bodyClassName="!pb-4">
      <p className="text-sm text-slate-700 dark:text-slate-300 mb-4 leading-relaxed">{content}</p>
      <div className="flex justify-end gap-2.5">
        <Btn variant="secondary_outline" onClick={onCancel} disabled={loading}>{t("btn_cancel")}</Btn>
        <Btn
          variant={danger ? "solid_danger" : "primary"}
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
          className="min-w-[90px]"
        >
          {displayConfirmText}
        </Btn>
      </div>
    </Modal>
  );
}
